import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import { mapGetters } from 'vuex';
import { Component, Prop, Vue } from "vue-property-decorator";
let User = class User extends Vue {
    user;
    avatar;
    noSpecialty;
    getItemById;
    getSpecialtyInStore;
    get localUser() {
        return this.getItemById(this.user);
    }
    get specialty() {
        return this.getSpecialtyInStore(this.localUser.specialtyId);
    }
};
__decorate([
    Prop(String)
], User.prototype, "user", void 0);
__decorate([
    Prop(Boolean)
], User.prototype, "avatar", void 0);
__decorate([
    Prop(Boolean)
], User.prototype, "noSpecialty", void 0);
User = __decorate([
    Component({
        components: {
            Avatar
        },
        computed: {
            ...mapGetters('my-team', { getItemById: 'get' }),
            ...mapGetters('specialty', { getSpecialtyInStore: 'get' }),
        }
    })
], User);
export default User;
